<template>
  <div class="list_page">
    <div class="problemContainer">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="base">
          <template #title>
            <span>
              <img src="../../assets/svg/bsaicIcon.svg" alt="" />
              基本信息
            </span>
          </template>
          <el-descriptions :column="3" border>
            <el-descriptions-item label="车辆升级单号">
              {{ form.upgradeOrderNum || form.upgradeOrderId }}
            </el-descriptions-item>
            <el-descriptions-item label="主题">{{
              form.subject
            }}</el-descriptions-item>
            <el-descriptions-item label="质量反馈单号">{{
              form.qualityFeedbackId
            }}</el-descriptions-item>
            <el-descriptions-item label="OA报告名称">{{
              form.oaReportName
            }}</el-descriptions-item>
            <el-descriptions-item label="升级结束时间">{{
              form.upgradeEndDate
            }}</el-descriptions-item>
          </el-descriptions>
        </el-collapse-item>
      </el-collapse>
      <!-- 升级方案 -->
      <el-collapse v-model="activeNames">
        <el-collapse-item name="plan">
          <template #title>
            <span>
              <img src="../../assets/svg/bsaicIcon.svg" alt="" />
              升级方案
            </span>
          </template>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="升级原因">{{
              form.upgradeReason
            }}</el-descriptions-item>
            <el-descriptions-item label="附件">
              <file-upload-list v-if="reasonFiles.length > 0" :fileList="reasonFiles"></file-upload-list>
            </el-descriptions-item>
            <el-descriptions-item label="升级措施">{{
              form.upgradeMeasure
            }}</el-descriptions-item>
            <el-descriptions-item label="附件">
              <file-upload-list v-if="measureFiles.length > 0" :fileList="measureFiles"></file-upload-list>
            </el-descriptions-item>
            <el-descriptions-item label="索赔要求">{{
              form.claimRequirement
            }}</el-descriptions-item>
            <el-descriptions-item label="附件">
              <file-upload-list v-if="claimFiles.length > 0" :fileList="claimFiles"></file-upload-list>
            </el-descriptions-item>
          </el-descriptions>
        </el-collapse-item>
      </el-collapse>
      <!-- 车辆信息 -->
      <el-collapse v-model="activeNames">
        <el-collapse-item name="plan">
          <template #title>
            <span>
              <img src="../../assets/svg/carInfo.svg" alt="" />
              车辆信息
            </span>
          </template>
          <el-table
            :data="vinList"
            border
            stripe
            highlight-current-row
            max-height="450"
          >
            <el-table-column
              type="index"
              label="序号"
              width="60"
              align="center"
            ></el-table-column>
            <el-table-column
              label="VIN"
              prop="vin"
              min-width="180"
            ></el-table-column>
            <el-table-column
              label="品牌"
              prop="carBrand"
              min-width="120"
            ></el-table-column>
            <el-table-column
              label="车型"
              prop="carModel"
              min-width="120"
            ></el-table-column>
            <el-table-column
              label="订单号"
              align="center"
              prop="orderNum"
              min-width="140"
            ></el-table-column>
            <el-table-column label="国家" min-width="160" prop="countryName">
              <template slot-scope="{ row }">{{
                row.countryName || findCountryName(row.countryDataId)
              }}</template>
            </el-table-column>
            <el-table-column
              label="生产日期"
              width="160"
              align="center"
              prop="productionDate"
            ></el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
      <!-- 故障件信息 -->
      <el-collapse v-model="activeNames">
        <el-collapse-item name="fault">
          <template #title>
            <span>
              <img src="../../assets/svg/carInfo.svg" alt="" />
              故障件信息
            </span>
          </template>
          <p class="typeName">主因故障件</p>
          <el-table
            :data="primaryFaultList"
            border
            size="medium"
            stripe
            max-height="450"
          >
            <el-table-column type="index" label="序号" width="60" align="center" />
            <el-table-column label="国家" min-width="100">
              <template slot-scope="{ row }">{{
                row.countryName || findCountryName(row.countryDataId)
              }}</template>
            </el-table-column>
            <el-table-column label="故障件件号" prop="faultPartNumber" min-width="160" />
            <el-table-column label="故障件名称" prop="faultPartName" min-width="140" />
            <el-table-column label="故障件单价" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.unitPrice) }}</template>
            </el-table-column>
            <el-table-column label="零部件来源" width="120" align="center">
              <template slot-scope="{ row }">
                {{ row.sourceOfComponents === 0 ? '海外免费件' : row.sourceOfComponents === 2 ? '供应商免费件' : row.sourceOfComponents === 1 ? '收费件' : formatNumber(row.sourceOfComponents) }}
              </template>
            </el-table-column>
            <el-table-column label="更换数量" prop="quantity" width="100" align="right" />
            <el-table-column label="维修方案" width="100" align="center">
              <template slot-scope="{ row }">
                {{ row.repairPlan === 0 ? '维修' : row.repairPlan === 1 ? '更换' : row.repairPlan === 2 ? '补发' : formatNumber(row.repairPlan) }}
              </template>
            </el-table-column>
            <el-table-column label="工时(h)" prop="workingHours" width="100" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.workingHours) }}</template>
            </el-table-column>
            <el-table-column label="运费" prop="shippingFee" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.shippingFee) }}</template>
            </el-table-column>
            <el-table-column label="关税" prop="tariff" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.tariff) }}</template>
            </el-table-column>
            <el-table-column label="差旅费" prop="travelPrice" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.travelPrice) }}</template>
            </el-table-column>
            <el-table-column label="其他费用" prop="otherExpenses" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.otherExpenses) }}</template>
            </el-table-column>
            <el-table-column label="管理费费率" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.managementFeeRate) }}</template>
            </el-table-column>
            <el-table-column label="工时费用" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.laborCost) }}</template>
            </el-table-column>
            <el-table-column label="材料费用" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.materialCost) }}</template>
            </el-table-column>
            <el-table-column label="故障件总金额" width="130" align="right">
              <template slot-scope="{ row }">{{ calcFaultTotal(row) }}</template>
            </el-table-column>
          </el-table>
          <p class="typeName">其他故障件</p>
          <el-table
            :data="otherFaultList"
            border
            size="medium"
            stripe
            max-height="450"
          >
            <el-table-column type="index" label="序号" width="60" align="center" />
            <el-table-column label="国家" min-width="100">
              <template slot-scope="{ row }">{{
                row.countryName || findCountryName(row.countryDataId)
              }}</template>
            </el-table-column>
            <el-table-column label="故障件件号" prop="faultPartNumber" min-width="160" />
            <el-table-column label="故障件名称" prop="faultPartName" min-width="140" />
            <el-table-column label="故障件单价" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.unitPrice) }}</template>
            </el-table-column>
            <el-table-column label="零部件来源" width="120" align="center">
              <template slot-scope="{ row }">
                {{ row.sourceOfComponents === 0 ? '海外免费件' : row.sourceOfComponents === 2 ? '供应商免费件' : row.sourceOfComponents === 1 ? '收费件' : formatNumber(row.sourceOfComponents) }}
              </template>
            </el-table-column>
            <el-table-column label="更换数量" prop="quantity" width="100" align="right" />
            <el-table-column label="维修方案" width="100" align="center">
              <template slot-scope="{ row }">
                {{ row.repairPlan === 0 ? '维修' : row.repairPlan === 1 ? '更换' : row.repairPlan === 2 ? '补发' : formatNumber(row.repairPlan) }}
              </template>
            </el-table-column>
            <el-table-column label="工时(h)" prop="workingHours" width="100" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.workingHours) }}</template>
            </el-table-column>
            <el-table-column label="运费" prop="shippingFee" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.shippingFee) }}</template>
            </el-table-column>
            <el-table-column label="关税" prop="tariff" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.tariff) }}</template>
            </el-table-column>
            <el-table-column label="差旅费" prop="travelPrice" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.travelPrice) }}</template>
            </el-table-column>
            <el-table-column label="其他费用" prop="otherExpenses" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.otherExpenses) }}</template>
            </el-table-column>
            <el-table-column label="管理费费率" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.managementFeeRate) }}</template>
            </el-table-column>
            <el-table-column label="工时费用" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.laborCost) }}</template>
            </el-table-column>
            <el-table-column label="材料费用" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.materialCost) }}</template>
            </el-table-column>
            <el-table-column label="故障件总金额" width="130" align="right">
              <template slot-scope="{ row }">{{ calcFaultTotal(row) }}</template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
      <!-- 费用信息 -->
      <el-collapse v-model="activeNames">
        <el-collapse-item name="fee">
          <template #title>
            <span>
              <img src="../../assets/svg/carInfo.svg" alt="" />
              费用信息
            </span>
          </template>
          <el-table
            :data="costList"
            border
            size="medium"
            stripe
            max-height="450"
          >
            <el-table-column type="index" label="序号" width="60" align="center" />
            <el-table-column label="国家" min-width="100">
              <template slot-scope="{ row }">{{
                row.countryName || findCountryName(row.countryDataId)
              }}</template>
            </el-table-column>
            <el-table-column label="总工时(h)" width="110" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.manHour) }}</template>
            </el-table-column>
            <el-table-column label="工时单价" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.hourlyRate) }}</template>
            </el-table-column>
            <el-table-column label="工时总费用" width="130" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.totalCostOfWork) }}</template>
            </el-table-column>
            <el-table-column label="材料总费用" width="130" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.materialTotalCost) }}</template>
            </el-table-column>
            <el-table-column label="总运费" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.freight) }}</template>
            </el-table-column>
            <el-table-column label="总关税" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.tariffTotal) }}</template>
            </el-table-column>
            <el-table-column label="其他总费用" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.otherTotalCost) }}</template>
            </el-table-column>
            <el-table-column label="总差旅费" width="120" align="right">
              <template slot-scope="{ row }">{{ formatNumber(row.travelPriceTotal) }}</template>
            </el-table-column>
            <el-table-column label="索赔总费用" width="130" align="right">
              <template slot-scope="{ row }">{{ calcCostTotal(row) }}</template>
            </el-table-column>
            <el-table-column label="其他费用说明原文" min-width="140" show-overflow-tooltip>
              <template slot-scope="{ row }">{{ row.otherInstruction || '' }}</template>
            </el-table-column>
            <el-table-column label="其他总费用说明" min-width="160" show-overflow-tooltip>
              <template slot-scope="{ row }">{{ row.otherInstructionZh || '' }}</template>
            </el-table-column>
            <el-table-column label="结算币种" width="100" align="center">
              <template slot-scope="{ row }">{{ row.currency === 0 ? 'CNY' : row.currency === 1 ? 'USD' : '' }}</template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="submitArea">
      <el-button plain @click="handleBack">返回</el-button>
    </div>
  </div>
</template>

<script>
import { vehicleUpgradeOrderDetailApi } from "@/api/vehicleUpgrade";
import { getNations } from "@/api/api";

export default {
  name: "VehicleUpgradeDetail",
  data() {
    return {
      activeNames: ["base", "plan", "fault", "fee"],
      form: {
        upgradeOrderId: "",
        upgradeOrderNum: "",
        subject: "",
        qualityFeedbackId: "",
        oaReportName: "",
        upgradeEndDate: "",
        upgradeReason: "",
        upgradeMeasure: "",
        claimRequirement: "",
      },
      reasonFiles: [],
      measureFiles: [],
      claimFiles: [],
      vinList: [],
      faultPartsList: [],
      costList: [],
      countryOptions: [],
    };
  },
  computed: {
    primaryFaultList() {
      return this.faultPartsList.filter((f) => Number(f.faultType) === 1);
    },
    otherFaultList() {
      return this.faultPartsList.filter((f) => Number(f.faultType) !== 1);
    },
  },
  created() {
    this.loadCountry();
    const id = this.$route.query.id;
    if (id) {
      this.form.upgradeOrderId = id;
      this.loadDetail(id);
    }
  },
  methods: {
    loadCountry() {
      getNations()
        .then((res) => {
          if (res && (res.status === "0" || res.status === 0)) {
            const list = res.data || [];
            this.countryOptions = list.map((c) => ({ id: c.id, name: c.name }));
          }
        })
        .catch(() => {});
    },
    findCountryName(id) {
      const c = this.countryOptions.find((x) => x.id === id);
      return c ? c.name : "";
    },
    loadDetail(id) {
      vehicleUpgradeOrderDetailApi({
        data: { upgradeOrderId: id, mode: this.$route.query.mode || "quality" },
      })
        .then((res) => {
          if (!(res && (res.status === "0" || res.status === 0)) || !res.data) {
            this.$DonMessage.error((res && res.message) || "详情加载失败");
            return;
          }
          const d = res.data;
          this.form.upgradeOrderId = d.upgradeOrderId || id;
          this.form.upgradeOrderNum = d.upgradeOrderNum || "";
          this.form.subject = d.subject || "";
          this.form.qualityFeedbackId = d.qualityFeedbackId || "";
          this.form.oaReportName = d.oaReportName || "";
          this.form.upgradeEndDate = d.upgradeEndDate || "";
          this.form.upgradeReason = d.upgradeReason || "";
          this.form.upgradeMeasure = d.upgradeMeasure || "";
          this.form.claimRequirement = d.claimRequirement || "";
          this.vinList = (d.vinList || []).map((v) => ({ ...v }));
          this.faultPartsList = (d.faultPartsList || []).map((f) => ({ ...f }));
          this.costList = (d.costList || []).map((c) => ({ ...c }));
          this.reasonFiles = (d.reasonFiles || []).map((f) => ({ ...f }));
          this.measureFiles = (d.measureFiles || []).map((f) => ({ ...f }));
          this.claimFiles = (d.claimFiles || []).map((f) => ({ ...f }));
        })
        .catch(() => {
          this.$DonMessage.error("详情加载失败");
        });
    },
    getUrl(f) {
      return f.fileUrl || f.url || f.filePath || f.path || "";
    },
    getName(f) {
      return f.fileName || f.name || this.getUrl(f).split("/").pop() || "附件";
    },
    isImage(f) {
      const name = this.getName(f).toLowerCase();
      return /\.(png|jpe?g|gif|bmp|webp|svg)$/i.test(name);
    },
    getImagePreviewList(list) {
      return (list || [])
        .filter((f) => this.isImage(f))
        .map((f) => this.getUrl(f));
    },
    formatNumber(v) {
      if (v === null || v === undefined || v === "") return "-";
      const n = Number(v);
      if (Number.isNaN(n)) return v;
      return n.toFixed(2);
    },
    n(v) {
      const num = Number(v);
      return isNaN(num) ? 0 : num;
    },
    calcFaultTotal(row) {
      const total =
        this.n(row.laborCost) +
        this.n(row.materialCost) +
        this.n(row.shippingFee) +
        this.n(row.tariff) +
        this.n(row.travelPrice) +
        this.n(row.otherExpenses);
      return total.toFixed(2);
    },
    calcCostTotal(row) {
      const total =
        this.n(row.totalCostOfWork) +
        this.n(row.materialTotalCost) +
        this.n(row.freight) +
        this.n(row.tariffTotal) +
        this.n(row.otherTotalCost) +
        this.n(row.travelPriceTotal);
      return total.toFixed(2);
    },
    handleBack() {
      this.$router.back();
    },
  },
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<style src="@/components/problemDetails/problemDetail.css"></style>
<style scoped>
.typeName {
  font-size: 15px;
  font-weight: bold;
  margin: 5px 0;
}

</style>

